import React from 'react';
import { StructuredText } from 'react-datocms';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, sectionMargins, standardColours } from '../styles';
import { Container, Heading, HtmlContent, Link } from './ui';
import { buildUrl } from '../utils';

const StyledContent = styled.section`
  ${({ isDetail }) => {
    if (isDetail) {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    } else {
      return css`
        ${sectionMargins()};
      `;
    }
  }}
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}
`;

const StyledInner = styled(HtmlContent)`
  ${({ twoColumns }) => {
    if (twoColumns) {
      return css`
        ${minBreakpointQuery.mlarge`
          column-count: 2;
          column-gap: 60px;
        `}

        ${minBreakpointQuery.large`
          column-gap: 80px;
        `}

        ${minBreakpointQuery.xxlarge`
          column-gap: 100px;
        `}
      `;
    }
  }};

  ${({ highlight }) => {
    if (highlight) {
      return css`
        padding: 30px;
        background-color: ${standardColours.lightGrey};

        ${minBreakpointQuery.small`
          padding: 40px;
        `}

        ${minBreakpointQuery.medium`
          padding: 60px;
        `}

        ${minBreakpointQuery.large`
          padding: 80px;
        `}

        ${minBreakpointQuery.xxlarge`
          padding: 100px;
        `}
      `;
    }
  }};
`;

const Content = ({ heading, content, twoColumns, isDetail }) => (
  <StyledContent isDetail={isDetail}>
    <Container>
      {heading && <StyledHeading alt={true}>{heading}</StyledHeading>}
      <StyledInner twoColumns={twoColumns}>
        <StructuredText
          data={content}
          renderInlineRecord={({ record }) => {
            return <Link to={record.pageUrl}>{record.text}</Link>;
          }}
          renderLinkToRecord={({ record, transformedMeta, children }) => {
            return transformedMeta && transformedMeta.target === '_blank' ? (
              <a
                href={buildUrl(record.pageUrl.slug, record.pageUrl)}
                {...transformedMeta}
              >
                {children}
              </a>
            ) : (
              <Link to={record.pageUrl}>{children}</Link>
            );
          }}
        />
      </StyledInner>
    </Container>
  </StyledContent>
);

export default Content;
